// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1ZWVi","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3VAS5"};